import { render, staticRenderFns } from "./kpi-registering.vue?vue&type=template&id=c9c8f7d6&scoped=true"
import script from "./kpi-registering.vue?vue&type=script&lang=js"
export * from "./kpi-registering.vue?vue&type=script&lang=js"
import style0 from "./kpi-registering.vue?vue&type=style&index=0&id=c9c8f7d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c8f7d6",
  null
  
)

export default component.exports